<div class="col-sm-12 d-flex" style="justify-content: end;">
  <div class="pull-right" *ngFor="let button of buttonLabels" style="margin-right: 1%;">
    <span class="button-continer" style="width:auto; float: left;">
      <button *ngIf="button == 'Cancel'" mat-stroked-button class="cancelButton" (click)="backbtn()">{{button}}</button>
      <button *ngIf="button != 'Cancel' && button != ''" mat-stroked-button class="addButton"
        (click)="dynamicButtonClick1(button)">{{button}}</button>
    </span>
  </div>
</div>
<div class="form form-content ng-star-inserted">
  <div class="row">
    <div class="col-md-12 d-flex ">
      <div class="col-md-5 p-1">
        <!-- Justification For Parallel Workflow -->
        <div><label id="justification-validation" for="email">{{dynamicLabel['REASON_FOR_WORKFLOW']}}</label></div>
        <textarea id="groupDescription" type="text"
          (change)="handleDropDownValidation('justification-validation',parallelWorkflowData.reasonForWorkflow)"
          class="input-filed-textarea" rows="4" cols="50"
          [(ngModel)]="parallelWorkflowData.reasonForWorkflow"></textarea>
      </div>
      <div class="col-md-4 p-1">
        <!-- Parallel Workflow Status -->
        <div><label for="email">{{dynamicLabel['STATUS']}}</label></div>
        <input class="input-filed-continers" type="text" [(ngModel)]="parallelWorkflowData.status" disabled>
      </div>
    </div>
  </div>
</div>



<div class="row">
  <div class="col-md-12">
    <mat-tab-group mat-stretch-tabs class="trainingtab mat-tab-container mat-elevation-z4" animationDuration="0ms"
      (selectedTabChange)="onTabChanged($event);">
      <mat-tab label="Users">
        <ng-template mat-tab-label>
          <span *ngIf="qmsservice.moduleName!='AU'">Workflow Actions</span>
          <span *ngIf="qmsservice.moduleName=='AU'">Workflow Findings</span>
        </ng-template>
        <app-parallel-workflow-actions
          *ngIf="qmsservice.moduleName!='AU'&&qmsservice.moduleName!='OOS'"></app-parallel-workflow-actions>
        <app-parallel-workflow-findings *ngIf="qmsservice.moduleName=='AU'"></app-parallel-workflow-findings>
        <app-parallel-workflow-oos-actions *ngIf="qmsservice.moduleName=='OOS'"></app-parallel-workflow-oos-actions>
      </mat-tab>
      <mat-tab label="Trainings">
        <ng-template mat-tab-label>
          <span>Workflow Stage Users</span>
        </ng-template>
        <app-stageusers *ngIf="showstageUsers" [activityData]="this.parallelWorkflowData"></app-stageusers>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>

<ng-template #confirmWithDataPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelConfirmWithDataFunc()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ buttonLabel }}</label>
  </div>
  <div style="margin: 15px 15px;">
    <div class="form-continer">
      <div class="row">
        <div class="col-md-12">
          <div class="row" *ngIf="this.statusDropdown.length > 0">
            <div class="col-md-3" style="margin-top: 8px;"><label id="status-validation"
                for="status">Status</label><span class="mandatory-symbol">*</span></div>
            <div class="col-md-9">
              <mat-radio-group class="tp-radio-group" [(ngModel)]="selectedStatus">
                <mat-radio-button class="tp-radio-button" (change)="onStatusSelect($event)"
                  *ngFor="let status of statusDropdown" [value]="status.valueExp">
                  {{status.displayExp}}
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div class="row" *ngIf="isEsignRequired">
            <div class="col-md-3"><label for="username ">User Name</label></div>
            <div class="col-md-9"> <input style="height: 80% !important;" class="input-filed-continers" type="text"
                [(ngModel)]="userName" disabled>
            </div>
          </div>
          <div class="row" *ngIf="(isEsignRequired && !isAdenabled)">
            <div class="col-md-3"><label id="password-validation" for="pass">Password</label><span
                class="mandatory-symbol">*</span></div>
            <div class="col-md-9">
              <input style="height: 80% !important;" class="input-filed-continers"
                [type]="changetypeAddAndEditPassword ? 'password' : 'text'" [(ngModel)]="password"
                (focusout)="onPasswordFieldFocusout()" noCopyPaste>
              <span class="eyeicon-container eye-color" (click)="showPassword()" (keydown.enter)="showPassword()">
                <i
                  [class]="changetypeAddAndEditPassword ? 'fas fa-eye-slash' : 'fa fa-fw fa-eye field-icon toggle-password'"></i>
              </span>
            </div>
          </div>
          <div class="row" *ngIf="isShowRejectReason" style="margin-bottom: 5%;">
            <div class="col-md-4"><label id="rejectReason-validation" for="rejectReason">Reject Reason</label><span
                class="mandatory-symbol">*</span></div>
            <div class="col-md-8" style="margin-left: -45px;">
              <ng-multiselect-dropdown id="rejectReason" style="position: absolute; width: 62%;"
                class="multiselect-container" [(ngModel)]="selectedRejectReason"
                [settings]="singleSelectDropdownSetting" [data]="rejectReasonDropdown"
                (onSelect)="onRejectReasonSelect($event)">
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3"><label for="comment" id="comment-validation">Comments</label><span
                class="mandatory-symbol">*</span>
            </div>
            <div class="col-md-9">
              <textarea id="comment" class="input-filed-textarea" rows="4" cols="50" [(ngModel)]="comments"
                (focusout)="onPasswordFieldFocusout()"></textarea>
            </div>
          </div>
          <div class="row field-style1">
            <div class="col-md-3"><label for="comment">Document</label></div>
            <div class="col-md-9">
              <input type="file" class="file-input" (change)="onConfirmFileSelected($event)" #fileUpload>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="confirmWithDataFunc()">
        Submit
      </button>

      <button mat-stroked-button class="cancelButton" (click)="cancelConfirmWithDataFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #confirmPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelConfirmFunc()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ title }}</label>
  </div>
  <div style="margin: 15px 15px;">
    <div class="">
      <div class="">
        <div class="col-md-12">
          <div class="row" *ngIf="(isEsignRequired)">
            <div class="col-md-3"><label for="pass">User Name</label><span class="mandatory-symbol">*</span></div>
            <div class="col-md-9"> <input style="height: 80% !important;" class="input-filed-continers" type="text"
                [(ngModel)]="userName" disabled>
            </div>
          </div>
          <div class="row" *ngIf="(isEsignRequired && !isAdenabled)">
            <div class="col-md-3"><label id="password-validation" for="pass">Password</label><span
                class="mandatory-symbol">*</span></div>
            <div class="col-md-9">
              <input style="height: 80% !important;" class="input-filed-continers"
                [type]="changetypeAddAndEditPassword ? 'password' : 'text'" [(ngModel)]="password"
                (focusout)="onPasswordFieldFocusout()">
              <span class="eyeicon-container eye-color" (click)="showPassword()" (keydown.enter)="showPassword()"
                noCopyPaste>
                <i
                  [class]="changetypeAddAndEditPassword ? 'fas fa-eye-slash' : 'fa fa-fw fa-eye field-icon toggle-password'"></i>
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3"><label for="comment" id="comment-validation">Comments</label><span
                class="mandatory-symbol">*</span>
            </div>
            <div class="col-md-9">
              <textarea class="input-filed-textarea" rows="4" cols="50" [(ngModel)]="comments"
                (focusout)="onPasswordFieldFocusout()"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="confirmOkFunc()">
        {{buttonLabel}}
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelConfirmFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>